/**
 * Branding-asset uploads (logo/favicon). Local disk under the API; returns a
 * served URL to store on the actor's branding/settings. In mock mode it returns
 * a transient object URL so the preview still works offline.
 */
import { USE_MOCKS, mockDelay, apiUpload } from './client';

export interface UploadedAsset {
  url: string;
  name: string;
  size: number;
}

export const uploadAsset = (file: File): Promise<UploadedAsset> =>
  USE_MOCKS
    ? mockDelay({ url: URL.createObjectURL(file), name: file.name, size: file.size })
    : apiUpload<UploadedAsset>('/uploads/asset', file);
